import { Stack, StackProps, styled, CreateSlotsAndSlotProps } from '@mui/material';
import { ContentIsland, ContentIslandProps } from './ContentIsland';

export type FormContentIslandSlotProps = CreateSlotsAndSlotProps<
  {
    stack: typeof Stack;
  },
  {
    stack: StackProps;
  }
>;

export type FormContentIslandProps = ContentIslandProps & FormContentIslandSlotProps;

const StyledStack = styled(Stack, {
  name: 'FormContentIsland',
  slot: 'stack',
})(({ theme }) => ({
  padding: theme.spacing(3, 4),
}));

export function FormContentIsland({
  children,
  slots,
  slotProps,
  ...props
}: FormContentIslandProps) {
  const StackComponent = slots?.stack ?? StyledStack;

  return (
    <ContentIsland {...props}>
      <StackComponent direction="column" spacing={4} {...slotProps?.stack}>
        {children}
      </StackComponent>
    </ContentIsland>
  );
}
